import { Component, EventEmitter, Input, OnInit, Output, TrackByFunction } from '@angular/core'
import { AutomationViewGroup } from '@tokeet-frontend/automations'

@Component({
  selector: 'app-automation-grid',
  templateUrl: './automation-grid.component.html',
  styleUrls: ['./automation-grid.component.scss'],
})
export class AutomationGridComponent implements OnInit {
  @Input() items: AutomationViewGroup[] = []

  @Output() edit = new EventEmitter<AutomationViewGroup>()

  constructor() {}

  trackBy: TrackByFunction<AutomationViewGroup> = (index, automation) => automation.group_id

  ngOnInit(): void {}
}
